import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { Loading } from "element-ui";
var RequestLoading = /*#__PURE__*/function () {
  function RequestLoading(loadingOptions) {
    _classCallCheck(this, RequestLoading);
    _defineProperty(this, "loadingOptions", {
      // target: ".app-main .el-scrollbar",
      lock: true,
      background: "rgba(0, 0, 0, 0.3)"
      // spinner: "el-icon-loading"
    });
    this.loadingOptions = _objectSpread(_objectSpread({}, this.loadingOptions), loadingOptions);
    this.loadingInstance = null;
    this.needLoadingRequestCount = 0;
  }
  _createClass(RequestLoading, [{
    key: "startLoading",
    value: function startLoading(loadingOptions) {
      this.loadingInstance = Loading.service(_objectSpread(_objectSpread({}, this.loadingOptions), loadingOptions));
    }
  }, {
    key: "endLoading",
    value: function endLoading() {
      this.loadingInstance.close();
    }
  }, {
    key: "showFullScreenLoading",
    value: function showFullScreenLoading(loadingOptions) {
      if (this.needLoadingRequestCount === 0) {
        this.startLoading(loadingOptions);
      }
      this.needLoadingRequestCount++;
    }
  }, {
    key: "tryHideFullScreenLoading",
    value: function tryHideFullScreenLoading() {
      if (this.needLoadingRequestCount <= 0) return;
      this.needLoadingRequestCount--;
      if (this.needLoadingRequestCount === 0) {
        this.endLoading();
      }
    }
  }]);
  return RequestLoading;
}();
export { RequestLoading as default };